export default "__VITE_ASSET__DzVO2v5N__"